import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  prequalDataSelector,
  cartAmountSelector,
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";
import ProgressiveLogo from "../../../../../assets/img/progressive-logo.png";
import { addThousandsSeparator } from "../../../../../utils/helpers";
import DueTodayBreakdown from "../DueTodayBreakdown";
import "./styles.scss";

class PrequalOfferScreen extends Component {
  handleContinue = () => {
    const { prequalData, selectOffer, cartAmount } = this.props;

    selectOffer({
      selectedOffer: {
        app_id: prequalData.app_id,
        provider: 'progressive',
        specific_provider_name: 'progressive',
        banking_data: true,
        offer_id: prequalData.application_id,
        approval_amount: prequalData.approval_amount,
        has_additional_info: true,
        additional_info_data: {},
        cart_total: prequalData.cart_total || parseFloat(cartAmount) || 0,
      },
    });
  };

  render() {
    const { loading, prequalData } = this.props;

    if (!prequalData) return null;

    const approvalAmount = `$${addThousandsSeparator(prequalData.approval_amount)}`;
    const initialPayment = prequalData.initial_payment_total
      ? `$${addThousandsSeparator(prequalData.initial_payment_total)}`
      : null;
    const periodicPayment = prequalData.periodic_payment_total
      ? `$${addThousandsSeparator(prequalData.periodic_payment_total)}`
      : null;
    const installationFee = parseFloat(prequalData.installation_fee) || 0;

    return (
      <div className="expanded-block-component bank-data-form-container prequal-offer-screen">
        <div className="bank-data-form-header">
          <img src={ProgressiveLogo} alt="Progressive Logo" />
          <h1>You're Pre-Qualified!*</h1>
          <p>
            {`You've been pre-qualified to lease items up to ${approvalAmount} in cash price with Progressive Leasing.`}
          </p>

          <div className="approval-amount">
            <p className="font-bold">
              Pre-Qualified Amount <span className="font-bold">{approvalAmount}</span>
            </p>
          </div>

          {(initialPayment || periodicPayment) && (
            <div className="payment-details">
              {initialPayment && (
                <p>
                  Initial Payment <span>{initialPayment}</span>
                </p>
              )}
              {periodicPayment && (
                <p>
                  Periodic Payment <span>{periodicPayment}</span>
                </p>
              )}
            </div>
          )}

          {installationFee > 0 && (
            <DueTodayBreakdown
              initialPayment={prequalData.initial_payment_total || 1}
              installationFee={installationFee}
            />
          )}

          <p className="font-italic">
            * Approval is conditioned on providing a valid bank account and a valid payment card that are capable of supporting regularly scheduled lease payments. Not all banks or cards may qualify. The standard lease-to-own agreement offers 12 months to ownership and could cost more than double the cash price. Not all applicants are approved.
          </p>
        </div>

        <div className="footer">
          <BlueBtn loading={loading} onClick={this.handleContinue}>
            Continue
          </BlueBtn>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  prequalData: prequalDataSelector()(state),
  cartAmount: cartAmountSelector()(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

PrequalOfferScreen = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrequalOfferScreen);

export default PrequalOfferScreen;